import api from './api';

export interface Usuario {
    id?: string;
    usuario: string;
    username?: string;
    nombre?: string;
    password?: string;
    email?: string;
    role: string;
    createdAt?: string;
    lastLogin?: string;
}

export interface UsuarioSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

export interface UsuarioPagedResult {
    items: Usuario[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const usuarioService = {
    normalizeUsuario: (raw: any): Usuario => {
        const id = raw?.id != null ? String(raw.id).trim() : '';
        const usuario = String(raw?.usuario ?? id ?? raw?.username ?? raw?.userName ?? '').trim();
        const username = String(raw?.username ?? raw?.userName ?? raw?.nombre ?? raw?.name ?? raw?.usuario ?? id ?? '').trim();
        const nombre = String(raw?.nombre ?? raw?.name ?? raw?.fullName ?? raw?.displayName ?? '').trim();
        const email = String(raw?.email ?? raw?.mail ?? '').trim();
        const role = String(raw?.role ?? raw?.rol ?? '').trim();

        return {
            ...raw,
            id: id || undefined,
            usuario,
            username: username || undefined,
            nombre: nombre || undefined,
            email: email || undefined,
            role
        };
    },

    getUsuarios: async (params?: UsuarioSearchParams): Promise<Usuario[]> => {
        const response = await api.get('/api/Users', params ? { params } : {});
        const data = response.data;
        
        if (Array.isArray(data)) {
            return data.map(usuarioService.normalizeUsuario);
        }
        
        if (data && typeof data === 'object' && 'items' in data) {
            return (data.items as any[]).map(usuarioService.normalizeUsuario);
        }
        
        return [];
    },

    getUsuario: async (username: string): Promise<Usuario> => {
        const response = await api.get<Usuario>(`/api/Users/${encodeURIComponent(username)}`);
        return usuarioService.normalizeUsuario(response.data);
    },

    createUsuario: async (usuario: Usuario): Promise<Usuario> => {
        const response = await api.post<Usuario>('/api/Users', usuario);
        return response.data;
    },

    updateUsuario: async (username: string, usuario: Usuario): Promise<void> => {
        await api.put(`/api/Users/${encodeURIComponent(username)}`, usuario);
    },

    deleteUsuario: async (username: string): Promise<void> => {
        await api.delete(`/api/Users/${encodeURIComponent(username)}`);
    }
};

export default usuarioService;
